// src/context/AuthContext.js
import { useAuthStore } from '../store/useAuthStore';

export const useAuth = () => {
    const authData = useAuthStore((state) => state.authData);
    const setAuthData = useAuthStore((state) => state.setAuthData);
    return { authData, setAuthData };
};
